export default __webpack_public_path__ + "static/7-6578560810e3fc90c4a54ec06f538f2d.png";